// extracted by mini-css-extract-plugin
export default {"container":"lBQwl","grid":"Hk5Zo","desktop_header":"nY4HI","mobile_header":"d_gAk","left":"MGWb5","right":"JCalZ"};